module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/your_project_es-ff83e5c41b2f9ad7b2aeb1238d74083d.png";